<template>
  <div>Edit event</div>
</template>

<script>
export default {};
</script>

<style lang="css"></style>
